let store = require("../store");
let actions = require("../actions");

let SubjectFormView = require("./SubjectFormView");
let ArchiveView = require("./ArchiveView");
let SubjectTable = require("../widget/SubjectTable");
let LifecycleStateFlag = require("../widget/LifecycleStateFlag");
let SubjectUtil = require("../util/SubjectUtil");

let IconButton = mc.widgets.IconButton;
let QuickSearch = mc.widgets.QuickSearch;

class SubjectListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let state = store.getState();
    let studyId = this.props.studyId;

    return {
      study: state.study[studyId],
      prefs: state.prefs,
      complianceStats: state.studyComplianceStats,
      recordingStats: state.recordingStats,
      faultStats: state.faultStats,
      messages: state.unreadMessages.filter((msg) => msg.studyId === studyId)
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    this.loadData(this.props.studyId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.studyId !== this.props.studyId) {
      this.loadData(this.props.studyId);
    }
  }

  loadData(studyId) {
    let accountId = store.getState().user.user.accountId;

    actions.loadStudy(studyId);
    actions.loadStudyComplianceStats(studyId);
    actions.loadRecordingStats(studyId);
    actions.loadFaultStats(studyId);
    actions.loadUnreadMessages(accountId);
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  sortSubjects(key, direction) {
    actions.setPrefs({
      "subjectListSortKey": key,
      "subjectListSortDirection": direction
    });
  }

  editSubject() {
    let component = (
      <div>
        <h1>{tx("new_subject")}</h1>
        <SubjectFormView
          subject={null}
          studyId={this.props.studyId}
          onSave={this.onSaveSubject.bind(this)}
          onCancel={mc.ui.modal.bind(null)}/>
      </div>
    );

    mc.ui.modal(component, { width: "60%", minWidth: "600px", dismissable: false });
  }

  onSaveSubject(subject) {
    actions.loadStudy(this.props.studyId);
    mc.ui.modal(null);
    mc.ui.alert(tx("created_subject", { displayName: subject.displayName }));
  }

  setTerm(term) {
    this.setState({ term });
  }

  submitTerm(result) {
    mc.router.trigger("SUBJECT_DETAIL_VIEW", { studyId: result.studyId, subjectId: result.id });
  }

  setColumns(columns) {
    actions.setPref("subjectListCols", columns);
  }

  exportStudy() {
    ArchiveView.open(this.props.studyId);
  }

  downloadTable(results) {
    var table = document.querySelector("#rc-subject-table");

    var rows = [...table.querySelectorAll("tr")].map(function (tr) {
      return [...tr.querySelectorAll("td, th")].map(function (td) {
        return `"${td.innerText.replace(/"/g, "\"\"")}"`;
      });
    });

    var text = "\uFEFF" + rows.join("\n");

    mc.file.download("subjects.csv", "text/csv; charset=utf-8", text);
  }

  help() {
    mc.ui.help(`./help/${rc.lang}/subjects_table.html`);
  }

  render() {
    let {
      study = {},
      complianceStats,
      recordingStats,
      faultStats,
      messages = [],
      term = "",
      prefs = {}
    } = this.state;

    let subjects = study.subjects || [];
    let analyticsEnabled = study.pipelines && study.pipelines.length > 0;
    let studyStarted = study.lifecycleState !== "INITIALIZED";

    let results = SubjectUtil.merge(subjects, complianceStats, recordingStats, faultStats, messages, analyticsEnabled);
    let rows = mc.utils.filter(results, ["displayName"], term);
    let cols = prefs.subjectListCols || SubjectTable.DEFAULT_COL_PREF;

    return (
      <div className="rc-subject-list-view" data-study-id={study.id} data-study-name={study.displayName}>
        <div className="mc-split-layout">
          <h1>
            <span>{study.displayName || "..."}</span>
            <LifecycleStateFlag lifecycleState={study.lifecycleState}/>
          </h1>
          <div>
            <span className="rc-subject-list-view-count">
              {tx("count_subjects", { _count: subjects.length })}
            </span>
            <IconButton
              id="export_analytics_button"
              icon="download"
              label={tx("export")}
              scale={1.3}
              disabled={!analyticsEnabled || !studyStarted}
              onPress={this.exportStudy.bind(this)}/>
            <IconButton
              id="new_subject_button"
              icon="plus"
              label={tx("new_subject")}
              scale={1.4}
              disabled={!study.id || study.lifecycleState === "COMPLETE"}
              onPress={this.editSubject.bind(this)}/>
          </div>
        </div>
        <div className="mc-card">
          <div className="rc-subject-list-view-controls mc-split-layout">
            <QuickSearch
              term={term}
              results={rows}
              onChange={this.setTerm.bind(this)}
              onSubmit={this.submitTerm.bind(this)}
              placeholder={tx("search")}/>
            <div>
              <IconButton
                icon="help"
                onPress={this.help}/>
              <SubjectTable.Drop
                study={study}
                selected={cols}
                onSelect={this.setColumns.bind(this)}/>
            </div>
          </div>
          <div>
            <div className="rc-subject-list-view-container">
              <SubjectTable
                subjects={rows}
                study={study}
                cols={cols}
                sortKey={prefs.subjectListSortKey || "displayName"}
                sortDirection={prefs.subjectListSortDirection || 1}
                onSort={this.sortSubjects.bind(this)}/>
            </div>
          </div>
          {rows.length > 0 ? (
            <small>
              <a onClick={this.downloadTable.bind(this, results)}>
                {tx("download_table")}
              </a>
            </small>
          ) : null}
        </div>
      </div>
    );
  }
}

module.exports = SubjectListView;
